import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../config/firebase-config";

const useLoadPhoto = (key: string) => {
  const upload = async (userId: string, file: File) => {
    const storageRef = ref(storage, "/images/" + key + "/" + userId);
    const uploadTask = uploadBytesResumable(storageRef, file);
    await uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("upload is" + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload paused");
            break;
          case "running":
            console.log("Upload running");
            break;
          default:
            break;
        }
      },
      (error) => {
        console.log(error);
      },
      () => {}
    );

    return getDownloadURL(uploadTask.snapshot.ref);
  };
  return upload;
};

export default useLoadPhoto;
